import { SECTION_HREF } from '~/constants/sections'

const CONTENT_LINE_NUDGE = -36

function getScrollOffset() {
  const header = document.querySelector('.site-header')
  return (header?.getBoundingClientRect().height ?? 68) + 24
}

function getTopmostElement(...elements: Array<Element | null | undefined>) {
  const valid = elements.filter((el): el is Element => Boolean(el))
  if (valid.length === 0) return null

  return valid.reduce((top, el) =>
    el.getBoundingClientRect().top < top.getBoundingClientRect().top ? el : top
  )
}

function getScrollAnchor(section: Element, selector: string) {
  if (selector === SECTION_HREF.about) {
    const left = section.querySelector('.reveal')
    const right = section.querySelector('.about-right')
    const imageVisible = right instanceof HTMLElement && getComputedStyle(right).display !== 'none'

    if (imageVisible) {
      return getTopmostElement(left, right) ?? section
    }

    return section.querySelector('.section-label') ?? section
  }

  return section.querySelector('.section-head, .section-label') ?? section
}

function getScrollNudge(selector: string) {
  if (selector === SECTION_HREF.about) {
    const right = document.querySelector<HTMLElement>('#about .about-right')
    const imageVisible = right && getComputedStyle(right).display !== 'none'
    return imageVisible ? 0 : CONTENT_LINE_NUDGE
  }

  return CONTENT_LINE_NUDGE
}

export function useSmoothScroll() {
  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  function scrollToSection(selector: string) {
    const section = document.querySelector(selector)
    if (!section) return

    const anchor = getScrollAnchor(section, selector)
    const top = anchor.getBoundingClientRect().top + window.scrollY - getScrollOffset() + getScrollNudge(selector)

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    })
  }

  return { scrollToTop, scrollToSection }
}